import React from 'react';
import { AuthStore } from './netStore';

export type Stores = {
	auth: AuthStore,
}

export const StoresContext = React.createContext<Stores | null>(null)
